import React, { useCallback } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import CGUEmployeeModal from 'Modals/CGUEmployeeModal';
import LoginModal from 'Modals/LoginModal';
import CGUModal from 'Modals/CGUModal';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
const {
  app
} = window;
export default function BookingModals({
  ...props
}) {
  const cgu_employee_modal = BookingFormStore.useState(s => s.cgu_employee_modal);
  const login_modal = BookingFormStore.useState(s => s.login_modal);
  const cgu_modal = BookingFormStore.useState(s => s.cgu_modal);
  const cgu_e_trigger = BookingFormStore.useState(s => s.cgu_employee_modal_trigger);
  const login_trigger = BookingFormStore.useState(s => s.login_modal_trigger);
  const cgu_trigger = BookingFormStore.useState(s => s.cgu_modal_trigger);
  const closeLoginModal = useCallback(function (e) {
    BookingFormStore.update(function (store) {
      store.login_modal_trigger = undefined;
      store.login_modal = false;
    });
  }, []);
  const closeCGUModal = useCallback(function (e) {
    BookingFormStore.update(function (store) {
      store.cgu_modal_trigger = undefined;
      store.cgu_modal = false;
    });
  }, []);
  const closeCGUEmployeeModal = useCallback(function (e) {
    BookingFormStore.update(function (store) {
      store.login_modal_trigger = undefined;
      store.login_modal = false;
    });
  }, []);
  const handleLogin = useCallback(function (user) {
    BookingFormStore.update(s => {
      s.loading = true;
    });
    (async function () {
      try {
        var response = await ajaxRequest('/get-session');
      } catch (update) {
        BookingFormStore.update(function (store) {
          Object.keys(update).forEach(field => store[field] = update[field]);
        });
        return;
      }
      app.state.session = response;
      app.state.session.fetched = true;
      const update = {
        loading: false,
        info: undefined,
        error: undefined,
        warning: undefined,
        login_modal_trigger: undefined,
        login_modal: false
      };
      const is__auth = app.state.session?.user?.id ? true : false;
      const is__customer = is__auth && (app.state.session.user.roles || []).includes('customer');
      if (is__auth && !is__customer) {
        update.continue_as_guest = true;
      }
      BookingFormStore.update(function (store) {
        Object.keys(update).forEach(field => store[field] = update[field]);
      });
      app.emit({
        event: 'sessionChange',
        source: 'BookingComponent.handleLogin'
      });
    })();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoginModal, {
    onClose: closeLoginModal,
    open: login_modal,
    trigger_src: login_trigger,
    onLogin: handleLogin
  }), /*#__PURE__*/React.createElement(CGUModal, {
    onClose: closeCGUModal,
    open: cgu_modal,
    trigger_src: cgu_trigger
  }), /*#__PURE__*/React.createElement(CGUEmployeeModal, {
    onClose: closeCGUEmployeeModal,
    open: cgu_employee_modal,
    trigger_src: cgu_e_trigger
  }));
}
